<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" width="800px" :before-close="handleClose" append-to-body>
      <el-form :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="标题：" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="配图：" prop="file_url">
          <div class="file-input-box">
            <input class="file-input" type="file" name="file" accept="image/*" id="fileUpload"
              @change="handleFileImg" />
            <el-image v-if="form.file_url" class="img-box" :src="form.file_url"></el-image>
          </div>
          <div class="btn_cell">
            <el-button class="btn_ht" @click="handleOpenImg">历史图库</el-button>
          </div>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input class="auth-input" type="number" v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="1">显示</el-radio>
            <el-radio label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button type="default" @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>

      </div>
    </el-dialog>
    <el-dialog title="图库" :visible.sync="showLibrary" width="50%" append-to-body>
      <div class="ht_list">
        <div class="ht_item" v-for="(item, index) in imgList" :key="index">
          <el-image class="ht_img" fit="cover" :src="item.file_url" @click="handleImgItem(item)"></el-image>
          <div class="ht_item_id">{{ item.id }}</div>
        </div>
      </div>
      <el-pagination @current-change="pageChange2" :current-page.sync="pager2.page" hide-on-single-page
        :page-size="pager2.pagesize" layout="total, prev, pager, next" :total="pager2.count">
      </el-pagination>
    </el-dialog>
  </div>


</template>

<script>
import { getImgList, viewBanner, addBanner, updateBanner, uploadImg } from '@/utils/axios.js';
import { Base64 } from 'js-base64';


export default {
  name: 'HaleonBannerForm',

  data () {
    return {
      title: "新增",
      visible: false,
      showLibrary: false,
      imgList: [],
      imgFile: null, //图片文件 file
      form: {
        title: "",
        sort: 1,
        status: "1",
        fid: '',
        file_url: ""
      },
      fid: '',
      hasImg: false,
      pager2: {
        count: 0, // 总条数
        page: 1, // 当前页
        pagecount: 0, // 总页数
        pagesize: 10 // 每页条数
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],

        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ]

      }
    };
  },
  emits: ['updateBanner', 'close'],

  mounted () {

  },

  methods: {
    add () {
      this.visible = true;
      this.$refs.form.resetFields();
      this.hasImg = false;
      this.fid = '';
      console.log("新增");
      this.reset()
    },
    async edit (id) {
      if (!id) {
        this.$message.error('请选择要编辑的记录');
        return;
      }
      this.reset()

      const res = await viewBanner(id)
      console.log('viewBanner', res);
      if (res.code == 200) {
        const d = res.data

        this.form = {
          id: d.id,
          title: d.title,
          sort: d.sort,
          status: d.status,
          fid: d.fid,
          file_url: d.file_url
        }



        console.log("查看轮播图", d);

        this.title = "编辑";
        this.visible = true;
      }


      console.log("新增");
    },
    reset () {
      this.form = {
        title: "",
        fid: '',
        sort: 1,
        status: "1"
      }
    },
    handleOpen () {
      console.log('handleOpen');
      this.visible = true;
    },
    handleClose () {
      console.log('handleClose');
      this.imgFile = null;
      this.visible = false;
      this.showLibrary = false;
      this.reset()
      this.$emit('close')
    },
    handleOpenImg () {
      this.showLibrary = true
      this.handleImgList()
    },
    handleImgList () {
      getImgList(this.pager2).then((res) => {
        if (res.code == 200) {
          let result = JSON.parse(window.atob(res.data))
          this.imgList = result.data
          this.pager2 = result.pager;

          // 数值可能为字符串，需转换为number
          for (var key in this.pager2) {
            this.pager2[key] = parseInt(this.pager2[key]);
          }
        }
      })
    },
    handleImgItem (item) {
      this.imgFile = null;
      this.form.fid = item.id;
      this.form.file_url = item.file_url;
      this.hasImg = true;
      this.showLibrary = false;
    },
    pageChange2 (page) {
      this.pager2.page = page;
      this.handleImgList();
    },
    handleFileImg (e) {
      let file = e.target.files[0]
      this.imgFile = e.target.files[0]
      this.form.file_url = window.URL.createObjectURL(file)

      console.log("file", file, this.form.file_url);


      document.querySelector("#fileUpload").setAttribute('type', 'text');
      document.querySelector("#fileUpload").setAttribute('type', 'file')
    },
    async handleSubmit () {
      console.log("this.form", this.form);
      if (!this.form.file_url) {
        this.$message.error('请选择图片')
        return
      }
      const that = this;
      const valid = await this.$refs.form.validate()
      console.log("valid", valid);

      if (this.imgFile) {
        let formData2 = new FormData();
        formData2.append('file', this.imgFile)
        const res = await uploadImg(formData2)
        if (res.code == 200) {
          that.form.fid = res.file_id

        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg,
          });
          return
        }
      }
      if (this.form.id) {
        const res = await updateBanner(this.form)
        console.log("updateBanner", res);
        if (res.code == 200) {
          this.$message.success(res.msg || '修改成功');
        }
      } else {
        const res = await addBanner(this.form)
        console.log("addBanner", res);
        if (res.code == 200) {
          this.$message.success(res.msg || '新增成功');
        }
      }
      this.handleClose();

    }
  },
};
</script>



<style scoped>
.el-pagination {
  text-align: center;
}

.img-box {
  width: 64px;
  height: 64px;
  z-index: 9;
}

.file-input-box {
  position: relative;
  width: 66px;
  height: 66px;
  border: 1px solid #D5D8DE;
  cursor: pointer;
}

.file-input {
  position: absolute;
  width: 64px;
  height: 64px;
  opacity: 0;
  z-index: 11;
}

.file-input-del {
  padding-left: 18px;
  line-height: 20px;
  margin-top: -10px;
}

.file-input-del span {
  cursor: pointer;
}

.back-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 10px;
}

.edit-form>>>input::-webkit-outer-spin-button,
.edit-form>>>input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.edit-form>>>input[type="number"] {
  -moz-appearance: textfield;
}

.edit-form>>>.el-upload {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.edit-form>>>.tox .tox-menubar {
  background-color: #f3f4fc;
}

.edit-form>>>.tox .tox-mbtn {
  color: #333;
}

.edit-form>>>.tox .tox-tbtn {
  color: #333;
}

.edit-form>>>.tox .tox-tbtn svg {
  fill: #333;
}

.edit-form>>>.tox .tox-toolbar,
.edit-form>>>.tox .tox-toolbar__overflow,
.edit-form>>>.tox .tox-toolbar__primary {
  background-color: #f3f4fc;
  height: 40px;
  position: relative;
  border-bottom: 1px solid #aaa;
}

.edit-form>>>.tox .tox-tbtn--disabled,
.edit-form>>>.tox .tox-tbtn--disabled:hover,
.edit-form>>>.tox .tox-tbtn:disabled,
.edit-form>>>.tox .tox-tbtn:disabled:hover {
  color: #333;
}

.edit-form>>>.tox .tox-statusbar {
  background-color: #f3f4fc;
  color: #333;
  border-color: #aaa;
}

.edit-form>>>.tox .tox-statusbar a,
.edit-form>>>.tox .tox-statusbar__path-item,
.edit-form>>>.tox .tox-statusbar__wordcount {
  color: #333;
}

.edit-form>>>.tox-tinymce {
  border-color: #aaa;
}

.edit-form>>>.tox .tox-menubar+.tox-toolbar,
.edit-form>>>.tox .tox-menubar+.tox-toolbar-overlord .tox-toolbar__primary {
  border-color: #aaa;
}

.edit-form>>>.tox .tox-sidebar {
  border-color: #aaa;
}

.edit-form>>>.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
  border-color: #aaa;
}
</style>

<style lang="scss" scoped>
.file-input-box {
  padding-bottom: 6px;

  &::after {
    position: absolute;
    top: -4px;
    content: '+';
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 2;
  }
}

.edit-title {
  display: flex;
  align-items: center;
}

.edit-form {
  // margin-top: 0.32px;

  .title-input {
    width: 440px;
  }

  .auth-input {
    width: 240px;
  }

  .foot-submit {
    text-align: center;
  }

  .submit-btn {
    width: 200px;
    height: 48px;
    background: #6681FA;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    border: none;

    &::after {
      border: none;
      border-radius: 0;
    }
  }

  .el-button:active {
    background-color: #5B73DC;
  }
}

.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 1px solid #D5D8DE;
  border-radius: 4px;
}

.btn_ht {
  width: 130px;
  height: 40px;
  margin-top: 10px;
}

.ht_list {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.ht_item {
  width: 1.18rem;
  height: 1.18rem;
  margin-right: 0.2rem;
  margin-bottom: 40px;

  &:nth-child(5n) {
    margin-right: 0;
  }
}

.ht_img {
  width: 1.18rem;
  height: 1.18rem;
}

.ht_item_id {
  margin-top: 10px;
  text-align: center;
}

.goods_img {
  width: 1rem;
  height: 1rem;
}
</style>
